export function getOpenedModals(state) {
	return state.modals;
}
